import React, { useState } from "react";
import FileImport from "components/FileImport";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { licenseSetup } from "slices/systemAdmin/actions/license";
import { useDispatch } from "react-redux";
import Field, { fieldTypes } from "components/Field";

const LicenseSetupContent = () => {
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState("");

  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [userNameError, setUserNameError] = useState("");
  const [firstNameError, setFirstNameError] = useState(false);
  const [lastNameError, setLastNameError] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const isEnabled = () =>
    userName &&
    firstName &&
    lastName &&
    password &&
    confirmPassword &&
    selectedFile &&
    userNameError === "" &&
    firstNameError === false &&
    lastNameError === false &&
    passwordError === "" &&
    confirmPasswordError === "";

  const handleSubmit = () => {
    if (isEnabled()) {
      const formData = new FormData();
      const user = {
        userName,
        firstName,
        lastName,
        password,
      };
      const userJsonBlob = new Blob([JSON.stringify(user)], {
        type: "application/json",
      });
      formData.append("licenseFileField", selectedFile, selectedFile.name);
      formData.append("user", userJsonBlob);

      dispatch(licenseSetup(formData));
    }
  };

  return (
    <div className="license_setup__content" data-testid="license-setup-content">
      <h1>Setup VT Docs Instance</h1>
      <div className="license_setup__form">
        <h2>Setup your account</h2>
        <p>
          VisibleThread server must be configured with a valid license file and
          a System Administrator
        </p>
        <p>
          Please select a license file and provide details for the System
          Administrator to gain access to the server
        </p>
        <FileImport
          handleFileChange={handleFileChange}
          accepts=".lic"
          selectedFile={selectedFile}
          labelText="License File"
        />
        <Field
          type={fieldTypes.userName}
          propsObject={{
            userName,
            setUserName,
            userNameError,
            setUserNameError,
            labelText: "System Admin User",
          }}
        />
        <Field
          type={fieldTypes.firstName}
          propsObject={{
            firstName,
            setFirstName,
            firstNameError,
            setFirstNameError,
          }}
        />
        <Field
          type={fieldTypes.lastName}
          propsObject={{
            lastName,
            setLastName,
            lastNameError,
            setLastNameError,
          }}
        />
        <Field
          type={fieldTypes.passwordAndConfirm}
          propsObject={{
            password,
            setPassword,
            passwordError,
            setPasswordError,
            confirmPassword,
            setConfirmPassword,
            confirmPasswordError,
            setConfirmPasswordError,
          }}
        />
        <div className="license_setup__form__submit">
          <Button
            onClick={handleSubmit}
            variant={buttonVariants.primary}
            content="Submit"
            disabled={!isEnabled()}
          />
        </div>
      </div>
    </div>
  );
};

export default LicenseSetupContent;
